module.exports = __webpack_public_path__ + "media/images/icon_news-7cf6282fc3d8edfc2cb07cc586384dc3.png";